import Emittery from "emittery";
import { IMSelectorsUnion } from "../integrations/im/IMSelectorsTypes";

export const DOM_EVENT_TYPES = {
  HAS_LOADED: "HAS_LOADED",
  CONTACT_CHANGED: "CONTACT_CHANGED",
  NEW_THREAD_MESSAGE: "NEW_THREAD_MESSAGE",
  THEME_CHANGED: "THEME_CHANGED",
  BADGE_COUNT: "BADGE_COUNT",
} as const;

export type EventDataType = {
  [DOM_EVENT_TYPES.HAS_LOADED]: undefined;
  [DOM_EVENT_TYPES.CONTACT_CHANGED]: undefined;
  [DOM_EVENT_TYPES.NEW_THREAD_MESSAGE]: { id: string };
  [DOM_EVENT_TYPES.THEME_CHANGED]: { darkMode: boolean };
  [DOM_EVENT_TYPES.BADGE_COUNT]: { count: number };
};

export const IListenerServiceSymbol = Symbol.for("ListenerService");

export interface ListenerService extends Emittery<EventDataType> {
  startListenToMainChatWindowReplace(selectors?: IMSelectorsUnion): void;
}
